import { render, staticRenderFns } from "./ScormDisplay.vue?vue&type=template&id=be9b7ec4&"
import script from "./ScormDisplay.vue?vue&type=script&lang=js&"
export * from "./ScormDisplay.vue?vue&type=script&lang=js&"
import style0 from "./ScormDisplay.vue?vue&type=style&index=0&id=be9b7ec4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports